import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { SeoService } from '../core/services/seo.service';
import { NavigationComponent } from '../shared/navigation.component';
import { FooterComponent } from '../shared/footer.component';

@Component({
  selector: 'app-data-deletion',
  standalone: true,
  imports: [CommonModule, RouterModule, NavigationComponent, FooterComponent],
  templateUrl: './data-deletion.component.html',
  styleUrls: ['./data-deletion.component.css']
})
export class DataDeletionComponent implements OnInit {
  currentYear = new Date().getFullYear();
  lastUpdated = 'Abril 2026';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.seoService.updateSEOData({
      keywords: 'eliminación de datos, derecho de supresión, borrar datos personales, LFPDPPP, GDPR, WhatsApp datos, Pezeta Solutions',
      structuredData: {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Solicitud de Eliminación de Datos",
        "description": "Solicita la eliminación de tus datos personales almacenados en la plataforma Chatbot Pezeta de Pezeta Solutions. Proceso claro, plazo de 30 días.",
        "url": "https://chatbot.pezetasolutions.com/eliminacion-de-datos",
        "publisher": {
          "@type": "Organization",
          "name": "Pezeta Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://chatbot.pezetasolutions.com/images/gray-logo-80.webp"
          }
        },
        "dateModified": "2026-04-28",
        "inLanguage": "es-MX"
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }
}
